import script from "./SystemVisitor.vue?vue&type=script&setup=true&lang=js"
export * from "./SystemVisitor.vue?vue&type=script&setup=true&lang=js"

import "./SystemVisitor.vue?vue&type=style&index=0&id=fab1a1da&scoped=true&lang=css"

import exportComponent from "D:\\Workspace-idea\\vue-space\\hwoms-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fab1a1da"]])

export default __exports__